import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export const UNAUTHORIZED = 'UNAUTHORIZED' as const;
type ErrorTag = typeof UNAUTHORIZED;
export const errorTagTypes: ErrorTag[] = [UNAUTHORIZED];
export const handleErrorTags = (
  error: FetchBaseQueryError | undefined
): readonly ErrorTag[] => {
  if (!error) {
    return [] as const;
  }

  if (error.status === 401) {
    return [UNAUTHORIZED] as const;
  }

  return [] as const;
};
